import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'duration'
})
export class DurationPipe implements PipeTransform {

    transform(value: number): string {
        if (value > 0 && value < 1) {
            return '1s';
        } else if (value >= 1 && value <= 59) {
            return moment.duration(value, 'seconds').get('seconds') + 's';
        } else if (value >= 60 && value <= 3599) {
            return moment.duration(value, 'seconds').get('minutes') + 'm:' + moment.duration(value, 'seconds').get('seconds') + 's';
        } else if (value >= 3600 && value <= 86399 ) {
            return moment.duration(value, 'seconds').get('hours') + 'h:' + moment.duration(value, 'seconds').get('minutes') + 'm';
        } else if (value >= 86400) {
            return moment.duration(value, 'seconds').get('days') + 'd ' + moment.duration(value, 'seconds').get('hours') + 'h:' + moment.duration(value, 'seconds').get('minutes') + 'm';
        } else if (value === 0) {
            return '0s';
        }
    }
}
